import React, { Component } from 'react'
import { Table, Tabs, TreeSelect, Button, Input, Switch, Row } from 'antd';
import Form from './lib/ui/form';
import { schema_to_field } from './lib/util';
import moment from 'moment';
import CustomDateRangePicker from './components/custom_date_range';
import { CustomStats } from './components/custom_stat';
import { TabButton, CustomSwitch, IconCard, IconButton, TransactionOverviewStatistics, TextTag } from './components/basic_items';
import TransactionReconcileItem from './components/transaction_reconcile_item';
import { COLORS } from './pages/theme';
import { MoodOutlined, PlaylistAddOutlined } from '@material-ui/icons';
import DebugFilePreview from './components/debug_file_preview';
import PendingReconciledItem from './components/pending_reconciled_items';
import NotificationItem from './components/notification_item';
import { PopUpForm } from './lib/ui/popupform';
import SourceMapItem from './components/source_map_item';
import JsonBlockCard from './components/json_block_card';
import BasicConfigForm from './lib/ui/basic_config_form';
import Title from 'antd/lib/typography/Title';
import AnimatedSearchInput from './components/animated_search_input';

const { TabPane } = Tabs;

let schema = [
  {
    "name": "reconciler_id",
    "display_name": "Processing for",
    "validation": {
      "type": "select",
      "url": '/my-reconcilers?type=card',
      "options": [{ text: 1, value: 1 }, { text: 2, value: 2 }],
      "required": true
    }
  },
  {
    "name": "source_id",
    "display_name": "Source",
    "validation": {
      "type": "FK",
      "send_params": true,
      "url": '/my-reconcilers/sources',
      "required": true,
      "validate_fk": true,
    }
  },
  {
    "name": "date_to",
    "display_name": "Date To (exclusive):",
    "validation": {
      "type": "date",
      "required": true
    }
  }
]
class TestPage extends Component {
  constructor(props) {

    super(props)

    this.state = {
      startDate: moment().subtract(1, 'days'),
      endDate: moment(),
      edit_id: null,
      data_field: schema_to_field(schema),
      form_data: {},
      edit_data: {},
      test_data: {}
    };
  };



  render() {

    const { form_data } = this.state;
    let form_schema = schema_to_field(form_data.config || []);
    // return <DebugFilePreview 
    // url={require('../src/csvtest.csv')}
    // extension="CSV"
    // highlighter_downloaded={true}
    // highlighter={[]}
    // />
    // return <div>
    //   <center><Title>FORM TEST VIEW</Title></center>
    //         <Form
    //           forCreate={true}
    //           initialData={this.state.test_data}
    //           parentData={this.state.test_data}
    //           submitted={this.state.submitted}
    //           onChange={(data) => {
    //             console.log("new form data is", data)
    //             this.setState({ test_data: data })
    //           }}
    //           fields={this.state.data_field}
    //           submitting={false}
    //           errorMessage={{}}
    //           validationErrors={{}}
    //         />
    // </div>;
    return (
      <div style={{
        height: '100%',
        backgroundColor: COLORS.main_bg_color
      }}>



        <div className='filter-card' style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          // width: '100%'
        }}>
          <div style={{
            width: '50%',
            borderRight: `1px solid ${COLORS.border_basic}`
          }}>
            <center><Title>SCHEMA EDITOR</Title></center>
            <Form
              forCreate={true}
              initialData={this.state.form_data}
              parentData={this.state.form_data}
              submitted={this.state.submitted}
              stringyfy={this.props.stringyfy}
              onChange={(data) => {
                console.log("new form data is", data)
                this.setState({ form_data: data })
              }}
              fields={[
                {
                  index: "config",
                  name: "JSON CONFIG",
                  type: 'complexconfig',
                  multiple: true,
                  count: 1,
                  isDraggable: true,
                  toggle_ui_json: true,
                  toggle_main_json: true,
                  main_json_size: 600,
                }
              ]}
              submitting={false}
              errorMessage={{}}
              validationErrors={{}}
            />
          </div>
          <div style={{
            width: '50%'
          }}>
            <center><Title>FORM VIEW</Title></center>
            <Form
              forCreate={true}
              initialData={this.state.edit_data}
              parentData={this.state.edit_data}
              submitted={this.state.submitted}
              onChange={(data) => {
                console.log("new form data is", data)
                this.setState({ edit_data: data })
              }}
              fields={form_schema}
              submitting={false}
              errorMessage={{}}
              validationErrors={{}}
            />
          </div>
        </div>

        {/* <PendingReconciledItem
          data={{
            "__references__": {
              "logs": [],
              "our_txn_relation": {
                "amount": 16699,
                "description": "CWDR/652258/384617XXXXXX8460",
                "id": "Nzk1NjU0MCwyMDE5LTA4LTIy",
                "parsed_data": {
                  "balance": 0,
                  "cr_amount": 16699,
                  "date": "2019-08-22",
                  "dr_amount": 0,
                  "entry_user_id": "XYZ",
                  "init_sol": "",
                  "inst_num": "",
                  "last_four_digit": "8460",
                  "pstd_user_id": "XYZ",
                  "terminal_id": "TERM72",
                  "trace_no": "652258",
                  "tran_id": "MDEXVYDVBK",
                  "tran_particular": "CWDR/652258/384617XXXXXX8460",
                  "tran_remarks": "TERM72/384617XXXXXX8460",
                  "value_date": "2019-08-22"
                },
                "transaction_id": "MDEXVYDVBK",
                "txn_date": "2019-08-22",
                "type": "C"
              },
              "their_txn_relation": {
                "amount": 16699,
                "description": "CWRR/652258/384617XXXXXX8460",
                "id": "Nzk1NjU0MSwyMDE5LTA4LTIy",
                "parsed_data": {
                  "balance": 0,
                  "cr_amount": 0,
                  "date": "2019-08-22",
                  "dr_amount": 16699,
                  "entry_user_id": "XYZ",
                  "init_sol": "",
                  "inst_num": "",
                  "last_four_digit": "8460",
                  "pstd_user_id": "XYZ",
                  "terminal_id": "TERM72",
                  "trace_no": "652258",
                  "tran_id": "WJIHOEKYLG",
                  "tran_particular": "CWRR/652258/384617XXXXXX8460",
                  "tran_remarks": "",
                  "value_date": "2019-08-22"
                },
                "transaction_id": "WJIHOEKYLG",
                "txn_date": "2019-08-22",
                "type": "D"
              }
            },
            "action": "Approve",
            "approved": false,
            "created_at": "2020-04-04 10:04:47",
            "group_id": "14",
            "id": "MzI0MjcyMSwyMDIwLTA0LTA0IDEwOjA0OjQ3",
            "label": 0,
            "manual": false,
            "our_amount": 16699,
            "our_data_type_id": "1",
            "our_txn_date": "Thu, 22 Aug 2019 00:00:00 GMT",
            "our_txn_id": 7956540,
            "reconciled_at": "Sat, 04 Apr 2020 10:04:47 GMT",
            "rejected": false,
            "rule_id": "27",
            "their_amount": 16699,
            "their_data_type_id": "1",
            "their_txn_date": "Thu, 22 Aug 2019 00:00:00 GMT",
            "their_txn_id": 7956541
          }}
        />

        <br></br>
        <NotificationItem
          data={{
            "created_at": "2020-04-15 12:26:45",
            "id": 1,
            "message": "Report 'Domestic Nostro 102' has been successfully generated..",
            "notification_generator": "GENERATE_REPORT",
            "seen": false,
            "title": "Report Generated",
            "trigger_actions": [
              {
                "id": "REPORT_VIEW",
                "label": "View Report",
                "params": {
                  "id": "8"
                },
                "type": "VIEW"
              }
            ],
            "type": "SUCCESS",
            "user_id": 1
          }}
        />
        <br></br>
        <JsonBlockCard
          data={{
            "date": "2019-02-12",
            "value_date": "2019-02-12",
            "tran_particular": "BOALNPKA: 3914621",
            "entry_user_id": "XYZA",
            "vfd_user_id": "XYZA",
            "chq_no": "",
            "tran_remarks": "Electronic Fund Transfer",
            "dr_amount": 0,
            "cr_amount": 4541,
            "balance": 0,
            "source_id": "OFFICE-ACCOUNT-1"
          }}
          success={true}
          level={5}
        />
        <JsonBlockCard
          data={{
            "date": "2019-02-12",
            "value_date": "2019-02-12",
            "tran_particular": "BOALNPKA: 3914621",
            "entry_user_id": "XYZA",
            "vfd_user_id": "XYZA",
            "chq_no": "",
            "tran_remarks": "Electronic Fund Transfer",
            "dr_amount": 0,
            "cr_amount": 4541,
            "balance": 0,
            "source_id": "OFFICE-ACCOUNT-1"
          }}
          success={true}
          level={0}

        />

        <div className='filter-card'>
          <BasicConfigForm
            value={null}
            onChange={(value) => {
              console.log("value changed to", value)
            }}
          />

        </div> */}


      </div>
    );
  }
}

export default TestPage
